module.exports = __webpack_public_path__ + "img/icon-store.7dd57544.svg";